module.exports = __webpack_public_path__ + "static/hero-4b87faff89e8c466894e1c34fa01c9b5.svg";